import React, { useEffect, useState } from 'react';
import theme from './LicenseOverview.module.scss';
import { ProjectLicenseIssues, SortDirection } from 'types';
import { useAsyncStateWithIsLoading } from 'utils/hooks';
import { getLicenseIssues } from 'services/licenses';
import { createDataTable } from 'components/DataTable';
import {
    CustomLink,
    DateTimeDisplay,
    InfoIconWithTooltip,
    LoadingIndicator,
} from '@ygtechnologies/bygr-frontend-component-library';
import { orderBy, startCase } from 'lodash';

export interface LicenseOverviewProps {}
const DataTable = createDataTable<ProjectLicenseIssues>();

export const LicenseOverview: React.FC<LicenseOverviewProps> = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('projectName'));
    const [data, , , isLoading] = useAsyncStateWithIsLoading(() => getLicenseIssues(), [], null);

    const [sortedData, setSortedData] = useState(data);
    useEffect(() => {
        setSortedData(
            orderBy(data, tableState.sortBy, tableState.sortDirection === SortDirection.Ascending ? 'asc' : 'desc')
        );
    }, [tableState.sortBy, tableState.sortDirection, data]);

    if (!sortedData) {
        return <LoadingIndicator />;
    }
    return (
        <div>
            <h3>Licenses overview</h3>
            <DataTable
                isLoading={isLoading}
                data={sortedData}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={sortedData.length}
                hasPagination={false}
                className="table style-3">
                <DataTable.Column
                    sortable
                    header="Project Name"
                    field="projectName"
                    renderer={({ row, value }) => <CustomLink to={`/projects/${row.projectId}`}>{value}</CustomLink>}
                />

                <DataTable.Column
                    header="Issues"
                    field="licenseIssues"
                    sortable
                    renderer={({ value }) => (
                        <ul className={theme.issueList}>
                            {value.map((x) => (
                                <li key={x.module}>
                                    {startCase(x.module)} - {x.actualUnits} / {x.allowedUnits} units
                                    {x.note && <InfoIconWithTooltip content={x.note} />}
                                </li>
                            ))}
                        </ul>
                    )}
                />
                <DataTable.Column
                    sortable
                    header="Create date"
                    field="projectCreateDate"
                    renderer={({ row, value }) => <DateTimeDisplay value={value} />}
                />
            </DataTable>
        </div>
    );
};
